module.exports = __webpack_public_path__ + "img/vertical_6_7_5012.17717b46.png";